import { render, staticRenderFns } from "./AlterarSenha.vue?vue&type=template&id=6befcabd&"
import script from "./AlterarSenha.vue?vue&type=script&lang=js&"
export * from "./AlterarSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports